import script from "./LanguageComponent.vue?vue&type=script&setup=true&lang=tsx"
export * from "./LanguageComponent.vue?vue&type=script&setup=true&lang=tsx"

import "./LanguageComponent.vue?vue&type=style&index=0&id=98f8e18a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-98f8e18a"]])

export default __exports__